import React from "react";
import CountUp from "react-countup";
import Icon1 from "../Assets/img/funfact/funfact-1.png";
import Icon2 from "../Assets/img/funfact/funfact-2.png";
import Icon3 from "../Assets/img/funfact/funfact-3.png";
import Icon4 from "../Assets/img/funfact/funfact-4.png";
const Funfact = () => {
  const CountDownMain = [
    {
      id: "item1",
      icon: Icon1,
      countertextclass: "counter-text",
      number: "64",
      text: "District Coverage",
      csupportclass: "counter-support none",
    },
    {
      id: "item2",
      icon: Icon2,
      countertextclass: "counter-text",
      number: "6",
      text: "Country Reached",
      csupportclass: "counter-support none",
    },
    {
      id: "item3",
      icon: Icon3,
      countertextclass: "counter-text",
      number: "22",
      text: "Team Members",
      csupportclass: "counter-support none",
    },
    {
      id: "item4",
      icon: Icon4,
      countertextclass: "counter-text",
      number: "800",
      text: "Subscribers",
      csupportclass: "counter-support none",
    },
  ];

  return (
    <>
      <section className="funfact-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-8 col-12">
              <div className="funfact-title">
                <h3 className="fun-title">Things, we have achieved</h3>
                <p>
                  We are happy to say that we have many happy customers in many
                  areas, even outside of Bangladesh.
                </p>
              </div>
            </div>
          </div>
          <div className="row">
            {CountDownMain.map((SingleCardCount) => (
              <div
                className="col-lg-3 col-md-6 col-12"
                key={SingleCardCount.id}
              >
                <div className="single-count">
                  <div className="funfact-img">
                    <img src={SingleCardCount.icon} alt="#" />
                  </div>
                  <div className="funfact-content">
                    <h4 className={SingleCardCount.countertextclass}>
                      <span className="counter">
                        <CountUp end={SingleCardCount.number} duration={10} />
                      </span>
                      +
                    </h4>
                    <p>{SingleCardCount.text}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Funfact;
